import React from "react";
import type { TextColor } from "@/app/types/ui";

interface HeadingOneProps {
  children: React.ReactNode;
  color?: TextColor; // Pass the Tailwind text-color class you need
}

export const HeadingOne = ({
  children,
  color = "text-black",
}: HeadingOneProps) => {
  return <h1 className={`font-bold ${color} text-[32px]`}>{children}</h1>;
};
